import { registerCustomDetailComponent } from '@vendure/admin-ui/core';

import { CustomerSalesMetricsComponent } from './customer-sales-metrics.component';

export default [
    registerCustomDetailComponent({
        locationId: 'customer-detail',
        component: CustomerSalesMetricsComponent,
    }),
];
